var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQrCode(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 60,
    viewBox: "0 0 36 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_151",
    "data-name": "Rectangle 151",
    width: 36,
    height: 60,
    transform: "translate(-0.359 -0.163)",
    fill: "#0d0b0e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2684",
    "data-name": "Groupe 2684",
    transform: "translate(0.359 0.163)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2684-2",
    "data-name": "Groupe 2684",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_924",
    "data-name": "Trac\\xE9 924",
    d: "M30.709,0H4.574A4.579,4.579,0,0,0,0,4.574V55.1a4.579,4.579,0,0,0,4.574,4.574H30.709A4.579,4.579,0,0,0,35.282,55.1V4.574A4.579,4.579,0,0,0,30.709,0m2.4,55.1a2.4,2.4,0,0,1-2.4,2.4H4.574a2.4,2.4,0,0,1-2.4-2.4V4.574a2.4,2.4,0,0,1,2.4-2.4H30.709a2.4,2.4,0,0,1,2.4,2.4Z",
    fill: "#0d0b0e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_925",
    "data-name": "Trac\\xE9 925",
    d: "M70.316,232H65.089a1.089,1.089,0,1,0,0,2.178h5.227a1.089,1.089,0,0,0,0-2.178",
    transform: "translate(-50.061 -181.472)",
    fill: "#0d0b0e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_926",
    "data-name": "Trac\\xE9 926",
    d: "M33.089,71.4a1.089,1.089,0,0,0,1.089-1.089V66.178h4.138a1.089,1.089,0,0,0,0-2.178H33.089A1.089,1.089,0,0,0,32,65.089v5.227A1.089,1.089,0,0,0,33.089,71.4",
    transform: "translate(-25.031 -50.061)",
    fill: "#0d0b0e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_927",
    "data-name": "Trac\\xE9 927",
    d: "M102.316,64H97.089a1.089,1.089,0,0,0,0,2.178h4.138v4.138a1.089,1.089,0,1,0,2.178,0V65.089A1.089,1.089,0,0,0,102.316,64",
    transform: "translate(-75.092 -50.061)",
    fill: "#0d0b0e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_928",
    "data-name": "Trac\\xE9 928",
    d: "M39.4,142.316a1.089,1.089,0,0,0-1.089-1.089H34.178v-4.138a1.089,1.089,0,1,0-2.178,0v5.227a1.089,1.089,0,0,0,1.089,1.089h5.227a1.089,1.089,0,0,0,1.089-1.089",
    transform: "translate(-25.031 -106.38)",
    fill: "#0d0b0e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_929",
    "data-name": "Trac\\xE9 929",
    d: "M102.316,136a1.089,1.089,0,0,0-1.089,1.089v4.138H97.089a1.089,1.089,0,1,0,0,2.178h5.227a1.089,1.089,0,0,0,1.089-1.089v-5.227A1.089,1.089,0,0,0,102.316,136",
    transform: "translate(-75.092 -106.38)",
    fill: "#0d0b0e"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode);
export default __webpack_public_path__ + "static/media/qr-code.1847875560bac14d5ae00b454d89e8ff.svg";
export { ForwardRef as ReactComponent };